import { namespaceActions } from 'modules/app-core/redux-utils'
import constants, { NAME } from './constants'

export default namespaceActions(NAME)(constants)
